module.exports = __webpack_public_path__ + "assets/down-2613f53447811f4753a4f2ae34e92248.svg";